import StateType from './state.type';

export default {
  loading: false,
  totalEvents: 0,
  eventsEnum: [],
  events: [],
  modules: [],
} as StateType;
